import { object } from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import {
  FulfillmentCompleteS,
  FulfillmentCompleteTextS,
  FulfillmentCurrentNumberS,
  FulfillmentCurrentS,
  FulfillmentProgressBarS,
  FulfillmentProgressBarWrS,
  FulfillmentWrS,
} from './companyEditS';

const FulfillmentProgressBar = ({ percentFulfillment }) => {
  return percentFulfillment ? (
    <FulfillmentWrS>
      <FulfillmentCurrentS color="violet">
        <Trans i18nKey="companyEdit.progressBar.current" />
        <FulfillmentCurrentNumberS> {percentFulfillment}%</FulfillmentCurrentNumberS>
      </FulfillmentCurrentS>
      <FulfillmentProgressBarWrS>
        <FulfillmentProgressBarS withProgressBar={percentFulfillment} />
      </FulfillmentProgressBarWrS>
      {percentFulfillment < 100 && (
        <FulfillmentCompleteS>
          <FulfillmentCompleteTextS color="violet" align="right">
            <Trans i18nKey="companyEdit.progressBar.completeText" />
          </FulfillmentCompleteTextS>
        </FulfillmentCompleteS>
      )}
    </FulfillmentWrS>
  ) : null;
};

export default FulfillmentProgressBar;
